/** TODO - This component needs a rewrite */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import compose from 'utils/compose';

import CancelIcon from '@mui/icons-material/Cancel';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SearchIcon from '@mui/icons-material/Search';
import Input from '@mui/material/Input';

export const styles = (theme) => ({
  input: {},
  root: {},
  cancelIcon: {
    color: theme.palette.text.tertiary,
  },
  searchIconButton: {
    margin: 5,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  searchIcon: {
    margin: 3,
  },
  iconHolder: {
    lineHeight: '5px',
    '&:hover': {
      transform: 'scale(1.1)',
      transition: 'all 0.15s ease-in-out',
    },
    '&:active': {
      transform: 'scale(1)',
      transition: 'all 0.15s ease-in-out',
    },
  },
  smartSearch: {
    width: 38,
    marginRight: 'auto',
    marginLeft: '0px',
    minHeight: 32,
    padding: '0px 2px 0px 2px',
    borderRadius: '8px',
    marginBottom: 'auto',
    color: theme.palette.text.secondary,
    '&.open': {
      width: 270,
      transition: 'all 0.5s 0s ease-in',
      border: `1px solid ${theme.palette.primary.main}`,
      background: theme.palette.background.paper,
    },
    '&:hover': {
      color: theme.palette.primary.main,
      borderColor: theme.palette.action.hover,
      background: theme.palette.action.hover,
    },
    '&:focus-within': {
      color: theme.palette.primary.main,
      borderColor: `${theme.palette.primary.main} !important`,
    },
    transition: 'width 0.5s ease',
  },
  smartSearchInput: {
    ...theme.typography.paragraphRegular,
    color: theme.palette.text.primary,
    padding: '0px 5px 0px 5px',
    height: 'inherit',
    '&::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
    '&::-ms-clear ': {
      display: 'none',
    },
    '&.hide': {
      display: 'none',
    },
    '&.show': {
      display: 'block',
    },
  },
});

const fontStyle = { fontSize: '20px' };

class SearchBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      smartSearchText: props.initialValue || '',
      inputRef: null,
      activeSearch: false,
      searchOpen: Boolean(props.initialValue) || !props.collapsable,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.initialValue &&
      !nextProps.initialValue &&
      (this.props.autoSearchMinCount <= 2 || !this.props.autoSearchMinCount)
    ) {
      this.setState({ smartSearchText: '' });
    }
    if (nextProps.initialValue && nextProps.initialValue !== this.state.smartSearchText) {
      const smartSearchText = nextProps.initialValue || '';
      this.setState({ searchOpen: smartSearchText !== '', activeSearch: smartSearchText !== '', smartSearchText });
    }
  }

  saveInputRef = (el) => {
    this.state.inputRef = el;
  };

  resetFocus = () => {
    if (this.state.inputRef) {
      this.state.inputRef.focus();
    }
  };

  iconDoSearch = () => {
    if (this.state.searchOpen) {
      this.doSearch();
    } else {
      this.setState({ searchOpen: true });
      setTimeout(this.resetFocus, 100);
      // this.resetFocus();
    }
  };

  doSearch = (string = null) => {
    const filter = string || this.state.smartSearchText;
    if (filter.length > 0) {
      this.props.onSearch(filter);
      this.resetFocus();
      this.setState({ activeSearch: true });
    }
    if (filter.length === 0) {
      this.clearSearch();
    }
  };

  clearSearch = () => {
    this.setState({ activeSearch: false, smartSearchText: '' });
    this.props.onSearch('');
    this.resetFocus();
    this.setState({ searchOpen: !this.props.collapsable });
    if (this.props.onHelp) this.props.onHelp(false);
  };

  keyDown = (e) => {
    if (e.key === 'Enter') {
      this.doSearch();
      this.resetFocus();
    }
    if (e.key === 'Escape') {
      this.clearSearch();
      this.resetFocus();
      this.setState({ searchOpen: !this.props.collapsable });
    }
  };

  handleChange = (e) => {
    this.setState({ smartSearchText: e.target.value });

    if (this.props.autoSearch) {
      if (
        e.target.value.length >= (this.props.autoSearchMinCount || 2) ||
        this.state.smartSearchText.length >= (this.props.autoSearchMinCount || 2)
      ) {
        this.doSearch(e.target.value);
      } else {
        this.props.onSearch(null);
      }
    } else if (e.target.value.trim().length === 0 && this.state.activeSearch) {
      this.clearSearch();
    }
  };

  turnOnHelp = () => this.props.onHelp?.(true);

  render() {
    const { classes, collapsable, placeholder, className, onHelp, showUnderline, autoFocus, openClassName } =
      this.props;
    const showCancel = this.state.smartSearchText && this.state.smartSearchText.length > 0;

    let cancelAdorn = null;
    if (showCancel) {
      cancelAdorn = (
        <div className={classes.iconHolder}>
          <CancelIcon
            style={fontStyle}
            aria-label='Cancel Search'
            id='cancel-search'
            className={classNames(classes.cancelIcon, collapsable ? classes.searchIconButton : classes.searchIcon)}
            onClick={this.clearSearch}
            tabIndex='0'
          />
        </div>
      );
    } else if (onHelp && this.state.searchOpen) {
      cancelAdorn = (
        <div className={classes.iconHolder}>
          <HelpOutlineIcon
            style={fontStyle}
            aria-label='Cancel Search'
            id='help-search-adorn'
            className={collapsable ? classes.searchIconButton : classes.searchIcon}
            tabIndex='0'
            onClick={this.turnOnHelp}
          />
        </div>
      );
    }

    return (
      <Input
        autoFocus={autoFocus}
        autoComplete='transaction-search'
        inputProps={{
          'aria-label': 'Search',
          'data-testid': 'search',
        }}
        label='Search'
        sharedcomponentid='SEARCH_BOX'
        inputRef={this.saveInputRef}
        classes={{
          root: classNames(classes.smartSearch, this.state.searchOpen || !collapsable ? 'open' : 'show', classes.root),
          input: classNames(
            classes.smartSearchInput,
            classes.input,
            this.state.searchOpen || !collapsable ? 'show' : 'hide',
          ),
        }}
        className={classNames(className, this.state.searchOpen ? openClassName : '')}
        margin='dense'
        placeholder={placeholder || 'Search transactions'}
        value={this.state.smartSearchText}
        disableUnderline={!showUnderline}
        onKeyDown={this.keyDown}
        onChange={this.handleChange}
        startAdornment={
          <div className={classes.iconHolder}>
            <SearchIcon
              aria-label='Search'
              id='register-search-icon'
              className={collapsable ? classes.searchIconButton : classes.searchIcon}
              onClick={this.iconDoSearch}
              tabIndex='0'
            />
          </div>
        }
        endAdornment={cancelAdorn}
      />
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

SearchBox.propTypes = {
  // the 'classes' propType also allows for style overrides, much like MUI, for input, and input root
  // use this to customize the styles!
  classes: PropTypes.object,
  className: PropTypes.string,
  onSearch: PropTypes.func,
  autoSearch: PropTypes.bool,
  autoSearchMinCount: PropTypes.number,
  initialValue: PropTypes.string,
  collapsable: PropTypes.bool,
  openClassName: PropTypes.string,
  placeholder: PropTypes.string,
  onHelp: PropTypes.func,
  showUnderline: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(withStyles(SearchBox, styles));
